import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface ApiResponse {
  data: any[];
}

export interface ApiResponsePagination {
  data: any[];
  pagination: any;
}

@Injectable({
  providedIn: 'root'
})
export class PipelineRunsService {

  constructor(private http: HttpClient) { }

  getStatuses(): Observable<ApiResponsePagination> {
    let thisUrl = 'https://api.kubevirt-manager.io/api/statuses';
    
    return this.http.get<ApiResponsePagination>(thisUrl);
  }

  getPipelineRuns(): Observable<ApiResponsePagination> {
    let thisUrl = 'https://api.kubevirt-manager.io/api/pipelineruns';
    
    return this.http.get<ApiResponsePagination>(thisUrl);
  }

  getByColumn(column: string, value: string): Observable<ApiResponsePagination> {
    let thisUrl = 'https://api.kubevirt-manager.io/api/pipelineruns/by/' + column + '/' + value;
    
    return this.http.get<ApiResponsePagination>(thisUrl);
  }

  getProjects(): Observable<ApiResponse> {
    let thisUrl = 'https://api.kubevirt-manager.io/api/projects';
    
    return this.http.get<ApiResponse>(thisUrl);
  }

  getBranches(): Observable<ApiResponse> {
    let thisUrl = 'https://api.kubevirt-manager.io/api/branches';
    
    return this.http.get<ApiResponse>(thisUrl);
  }

  getPipelines(): Observable<ApiResponse> {
    let thisUrl = 'https://api.kubevirt-manager.io/api/pipelines';
    
    return this.http.get<ApiResponse>(thisUrl);
  }


}
